import {
    ACTION_TYPES,
    API_ACTIONS,
    API_ACTION_TYPES,
    ApiCall,
    EVENT_TYPE,
    createAction,
    useEventDataOfSelectedEvent,
} from "@Utils";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
    CALL_API_METHODS,
    HTTP_STATUS_SUCCESS_CODES,
} from "repoV2/constants/apis";

const fetchVariants = (listingUuid: string) => {
    const apiInfo = API_ACTIONS[API_ACTION_TYPES.GET_VARIANTS_DATA];
    return ApiCall({
        url: apiInfo.url({ listingUuid }),
        method: CALL_API_METHODS.GET,
    });
};

export const useFetchVariants = () => {
    const { eventData } = useEventDataOfSelectedEvent();
    const { uuid, type } = eventData;
    const dispatch = useDispatch();

    useEffect(() => {
        if (uuid && type === EVENT_TYPE.MERCHANDISE) {
            fetchVariants(uuid)
                .then((apiResponse: any) => {
                    const { status, data } = apiResponse?.data || {};
                    // status code 204 is intentionally added
                    if (
                        status === HTTP_STATUS_SUCCESS_CODES.HTTP_STATUS_OK ||
                        status ===
                            HTTP_STATUS_SUCCESS_CODES.HTTP_STATUS_NO_CONTENT
                    )
                        dispatch(
                            createAction(
                                ACTION_TYPES.EVENT.UPDATE_EVENT_LISTING_DATA,
                                {
                                    payload: {
                                        eventId: uuid,
                                        data,
                                        source: "variantsData",
                                    },
                                }
                            )
                        );
                })
                // this api will throw error if variants doesn't exists for this offering
                // no need to show any error in this case
                .catch(() => {});
        }
    }, [uuid]);
};
